"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lodash = void 0;
Object.defineProperty(exports, "packageVersion", {
  enumerable: true,
  get: function () {
    return _packageVersion.packageVersion;
  }
});
var _assign = _interopRequireDefault(require("./assign"));
var _clone = _interopRequireDefault(require("./clone"));
var _cloneDeep = _interopRequireDefault(require("./cloneDeep"));
var _debounce = _interopRequireDefault(require("./debounce"));
var _filter = _interopRequireDefault(require("./filter"));
var _find = _interopRequireDefault(require("./find"));
var _findIndex = _interopRequireDefault(require("./findIndex"));
var _forEach = _interopRequireDefault(require("./forEach"));
var _forIn = _interopRequireDefault(require("./forIn"));
var _forOwn = _interopRequireDefault(require("./forOwn"));
var _has = _interopRequireDefault(require("./has"));
var _isArray = _interopRequireDefault(require("./isArray"));
var _isDate = _interopRequireDefault(require("./isDate"));
var _isEmpty = _interopRequireDefault(require("./isEmpty"));
var _isEqual = _interopRequireDefault(require("./isEqual"));
var _isFunction = _interopRequireDefault(require("./isFunction"));
var _isNumber = _interopRequireDefault(require("./isNumber"));
var _isObject = _interopRequireDefault(require("./isObject"));
var _isPlainObject = _interopRequireDefault(require("./isPlainObject"));
var _keys = _interopRequireDefault(require("./keys"));
var _keysIn = _interopRequireDefault(require("./keysIn"));
var _last = _interopRequireDefault(require("./last"));
var _map = _interopRequireDefault(require("./map"));
var _mapValues = _interopRequireDefault(require("./mapValues"));
var _max = _interopRequireDefault(require("./max"));
var _merge = _interopRequireDefault(require("./merge"));
var _omit = _interopRequireDefault(require("./omit"));
var _omitBy = _interopRequireDefault(require("./omitBy"));
var _packageVersion = require("./packageVersion");
var _padStart = _interopRequireDefault(require("./padStart"));
var _pickBy = _interopRequireDefault(require("./pickBy"));
var _range = _interopRequireDefault(require("./range"));
var _reduce = _interopRequireDefault(require("./reduce"));
var _reject = _interopRequireDefault(require("./reject"));
var _toLower = _interopRequireDefault(require("./toLower"));
var _transform = _interopRequireDefault(require("./transform"));
var _trim = _interopRequireDefault(require("./trim"));
var _trimEnd = _interopRequireDefault(require("./trimEnd"));
var _trimStart = _interopRequireDefault(require("./trimStart"));
var _uniq = _interopRequireDefault(require("./uniq"));
var _values = _interopRequireDefault(require("./values"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const lodashPartial = {
  assign: _assign.default,
  clone: _clone.default,
  cloneDeep: _cloneDeep.default,
  debounce: _debounce.default,
  filter: _filter.default,
  find: _find.default,
  findIndex: _findIndex.default,
  forEach: _forEach.default,
  forIn: _forIn.default,
  forOwn: _forOwn.default,
  has: _has.default,
  isArray: _isArray.default,
  isDate: _isDate.default,
  isEmpty: _isEmpty.default,
  isEqual: _isEqual.default,
  isFunction: _isFunction.default,
  isNumber: _isNumber.default,
  isObject: _isObject.default,
  isPlainObject: _isPlainObject.default,
  keys: _keys.default,
  keysIn: _keysIn.default,
  last: _last.default,
  map: _map.default,
  mapValues: _mapValues.default,
  max: _max.default,
  merge: _merge.default,
  omit: _omit.default,
  omitBy: _omitBy.default,
  padStart: _padStart.default,
  pickBy: _pickBy.default,
  range: _range.default,
  reduce: _reduce.default,
  reject: _reject.default,
  toLower: _toLower.default,
  transform: _transform.default,
  trim: _trim.default,
  trimEnd: _trimEnd.default,
  trimStart: _trimStart.default,
  uniq: _uniq.default,
  values: _values.default
};
const lodash = lodashPartial;
exports.lodash = lodash;